import styled from "styled-components";
import { VStack } from "@sqymagma/elements";

const NewsWrapper = styled(VStack)`
  & > div {
    border-bottom: 1px solid ${(p) => p.theme.colors.brand05};
    padding-bottom: ${(p) => p.theme.spacing.xs};

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }
  }
`;

export { NewsWrapper };
